import cogoToast from 'cogo-toast';
import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_MANUAL_FACILITIES, GET_MANUAL_FACILITIES_SUCCESS, GET_MANUAL_FACILITIES_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getManualFacilities({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/manual/facility/${payload.bookingType}`,
      method: 'GET',
      headers: filteredHeaders,
    });

    if (response.status === 200) {
      const fileUrl = response?.data?.results?.url;
      if (fileUrl) {
        window.open(fileUrl, '_blank');
      } else {
        cogoToast.info('No facilities found for this vertical');
      }

      yield put({ type: GET_MANUAL_FACILITIES_SUCCESS, payload: response?.data });
    } else {
      cogoToast.error(response?.response?.data?.message || 'Failed to fetch facilities');
      yield put({ type: GET_MANUAL_FACILITIES_ERROR, payload: response?.response?.data?.message });
    }
  } catch (error) {
    cogoToast.error('Failed to fetch facilities');
    yield put({ type: GET_MANUAL_FACILITIES_ERROR, payload: error });
  }
}

export function* watchGetManualFacilities() {
  yield takeLatest(GET_MANUAL_FACILITIES, getManualFacilities);
}

function* getManualFacilitiesSaga() {
  yield all([fork(watchGetManualFacilities)]);
}

export default getManualFacilitiesSaga;
